import { DentalHireMenuHelper, Steps as StepsDental } from "../../../../components/dental-hire-menu/dental-hire-menu";
import { ForeignersHealthHireMenuHelper, StepsForeignersHealth } from "../../../../components/health-foreigners-hire-menu";
import { HealthHireMenuHelper, Steps as StepsSalud } from "../../../../components/health-hire-menu/health-hire-menu";
import { SaludPymesHireMenuHelper, StepsSaludPymes } from "../../../../components/salud-pymes-hire-menu";


export const requiredDocumentationRoutes = [
  {
    path: '/contratacion/nueva/salud/documentacion-requerida',
    nextStep: HealthHireMenuHelper,
    step: StepsSalud.DocumentacionRequerida,
    productType: 'salud',
    areaEndpoint: 'sendaHealth',
  },
  {
    path: '/contratacion/nueva/health/documentacion-requerida',
    nextStep: ForeignersHealthHireMenuHelper,
    step: StepsForeignersHealth.DocumentacionRequerida,
    productType: 'health',
    areaEndpoint: 'sendaHealth',
  },
  {
    path: '/contratacion/nueva/dental/documentacion-requerida',
    nextStep: DentalHireMenuHelper,
    step: StepsDental.DocumentacionRequerida,
    productType: 'dental',
    areaEndpoint: 'sendaDental',
  },
  {
    path: '/contratacion/nueva/salud-pymes/documentacion-requerida',
    nextStep: SaludPymesHireMenuHelper,
    step: StepsSaludPymes.DocumentacionRequerida,
    productType: 'salud-pymes',
    areaEndpoint: 'sendaHealth',
  },
];
